import * as React from 'react'
import './input-label.css'
import { withStatus } from '../modules/status'

@withStatus
export default class extends React.Component<any, any>{

    onHelpClick(e){
        console.log("Help click")
        this.props.actions.status.showMessage(null, this.props.help, null);
        e.preventDefault();
    }


    render(){
        const field = this.props.field;
        const label = this.props.label;
        const className = "input-label form-control-label " + (this.props.className || "")
        const help = this.props.help;

        return (
            <label className={ className } htmlFor={ field }>{ label } { help && 
                <i className="fa fa-lg fa-question-circle-o" aria-hidden="true" onClick={ this.onHelpClick.bind(this) }></i>
            }</label>
        )
    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/components/input-label.tsx